import List from "devextreme/ui/list";

/**
 * Popup options for the Sales Order operations drop-down buttons (the header's Operations button and the
 * Details / Primary detail grids' options buttons). Their lists run past the 400px popup, so the list's
 * scrollbar is kept visible: DevExtreme only shows it on hover on desktop, which hides that more
 * operations sit below. DropDownButton does not pass `showScrollbar` through to its list, so it is set
 * on the list once the popup is shown.
 */
export const operationsDropDownOptions = {
    width: 430,
    height: 400,
    onShown: (e) => {
        const listElement = e.component.content()?.querySelector(".dx-list");
        const list = listElement && List.getInstance(listElement);
        if (list && list.option("showScrollbar") !== "always") {
            list.option("showScrollbar", "always");
        }
    },
};
